import { render, staticRenderFns } from "./YogaProgramPhone.vue?vue&type=template&id=5395bdad&scoped=true&"
import script from "./YogaProgramPhone.vue?vue&type=script&lang=js&"
export * from "./YogaProgramPhone.vue?vue&type=script&lang=js&"
import style0 from "./YogaProgramPhone.vue?vue&type=style&index=0&id=5395bdad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5395bdad",
  null
  
)

export default component.exports